import { render, staticRenderFns } from "./ComparableTransactionsTaskStatus.vue?vue&type=template&id=3e640036&"
import script from "./ComparableTransactionsTaskStatus.vue?vue&type=script&lang=js&"
export * from "./ComparableTransactionsTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports